<template>
    <BaseLink
        :class="[$style.base_button_override, $style.mobile_override]"
        data-interface-target="youtube-header-button"
        :externalTo="YOUTUBE_HEADER_URL"
        target="_blank"
    >
        <img
            :class="$style.icon"
            :src="YoutubeImg"
            alt="Youtube"
        />
    </BaseLink>
</template>

<script setup lang="ts">
import BaseLink from '@/components/BaseLink.vue'
import { YOUTUBE_HEADER_URL } from '@/constants/general'

import YoutubeImg from './images/youtube.svg'
</script>

<style module>
.base_button_override {
    width: 48px;
    height: 48px;
    border-radius: 1000px;
    background: var(--carbon-400);
}

.mobile_override {
    display: none;
}

/* Phones only have room for the Playgama AI button */
@media (--tablet-plus) {
    .mobile_override {
        display: block;
    }
}

.icon {
    width: 48px;
    height: 48px;
}

@media (--desktop-small-plus) {
    .mobile_override {
        display: block;
    }

    .base_button_override {
        transition: box-shadow 0.3s;
        padding: 4px;
    }

    .base_button_override:hover,
    .base_button_override:focus {
        box-shadow: 0 0 30px 0 rgba(163, 109, 253, 0.64) inset;
        outline: 0.5px solid var(--purple-300);
    }
}
</style>
